import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsObjectSchemaRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object-schema',
	path: '/jira/servicedesk/assets/object-schema/:objectSchemaId',
};
